import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ApiConfig } from "@/config/api.config";
import { ApiHookProps } from '@/@types/api.types';
import { UrlHelper } from '@/utils/UrlHelper';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import { useTenantsFilter } from '@/features/superAdmin/features/tenants/hooks/useTenantsFilter';
import { TenantListResponseDto } from '@/features/superAdmin/features/tenants/types/superAdmin-tenants-dto';

type Props = {
    search?: string;
} & ApiHookProps;

export const useTenantsListApi = ({searchText}: Props = {}) => {
    const axiosInstance = useAxiosAuth();
    const { filter } = useTenantsFilter();
    const { take, skip, orderBy, orderDirection } = filter;

    const {
        data: tenantsListData, 
        isLoading: isLoadingTenantsListData, 
        isError: isErrorTenantsListData
    } = useQuery({
        queryKey: [
            ApiConfig.queries.superAdmin.tenants.queryKeys.list, 
            searchText, take, skip, orderBy, orderDirection
        ],
        queryFn: async (): Promise<TenantListResponseDto> => {
            const url = UrlHelper.buildUrlWithQueryParams(ApiConfig.queries.superAdmin.tenants.endpoints.list, {
                searchText, take, skip, orderBy, orderDirection
            });
            const response = await axiosInstance.get<TenantListResponseDto>(url);
            return response.data;
        },
        placeholderData: keepPreviousData
    });

    return {
        tenantsListData,
        isLoadingTenantsListData,
        isErrorTenantsListData,   
    }
}